import React from 'react';
import { useTranslation } from 'react-i18next';
import InfoElement from '../../components/InfoElement';
import ViewWrapper from '../../components/ViewWrapper';

const LandingPage = (): JSX.Element => {
    const { t: txt } = useTranslation();

    return (
        <ViewWrapper>
            <InfoElement
                iconName="error_outline"
                infoText={txt('NotSupportedBrowser.NotSupported')}
                testAttr="not-supported"
            />
        </ViewWrapper>
    );
};

export default LandingPage;
